import type { LoginResponse, SignupResponse, User } from '@/types'
import { request } from './client'

export async function login(login: string, password: string): Promise<LoginResponse> {
  return request<LoginResponse>('/login', {
    method: 'POST',
    body: { login, password },
    skipAuthRefresh: true,
  })
}

export async function signup(
  username: string,
  password: string,
  passwordConfirmation: string,
  email: string,
): Promise<SignupResponse> {
  return request<SignupResponse>('/signup', {
    method: 'POST',
    body: {
      username,
      password,
      passwordConfirmation,
      email,
    },
  })
}

export async function logout(): Promise<void> {
  await request<void>('/logout', { method: 'DELETE' })
}

export async function getMe(): Promise<User> {
  const response = await request<{ user: User }>('/me')
  return response.user
}

export async function requestPasswordReset(email: string): Promise<{ message: string }> {
  return request<{ message: string }>('/password_reset', {
    method: 'POST',
    body: { email },
  })
}

export async function confirmPasswordReset(
  token: string,
  password: string,
  passwordConfirmation: string,
): Promise<{ message: string }> {
  return request<{ message: string }>('/password_reset/confirm', {
    method: 'POST',
    body: {
      token,
      password,
      passwordConfirmation,
    },
  })
}

export async function deleteAccount(password: string): Promise<void> {
  await request<void>('/me', {
    method: 'DELETE',
    body: { password },
  })
}

export async function googleAuth(credential: string): Promise<LoginResponse> {
  return request<LoginResponse>('/auth/google', {
    method: 'POST',
    body: { credential },
    skipAuthRefresh: true,
  })
}
